import React from 'react';
import PropTypes from 'prop-types';

// Styles
import s from './filterGroupName.module.scss';
var FilterGroupName = function FilterGroupName(props) {
  var filterGroup = props.filterGroup,
    className = props.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(className, " ").concat(s.container)
  }, filterGroup);
};
FilterGroupName.propTypes = {
  filterGroup: PropTypes.string,
  className: PropTypes.string
};
FilterGroupName.defaultProps = {
  filterGroup: __('Untitled'),
  className: ''
};
export default FilterGroupName;